module.exports = __webpack_public_path__ + "static/img/thumb_18.6cd9408.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_18.png
// module id = 2Uky
// module chunks = 0